export const LS_ENCODED_DATA_FORM = 'LS_ENCODED_DATA_FORM';
export const LS_ENCODED_PAYMENT_PROFILE_ID = 'LS_ENCODED_PAYMENT_PROFILE_ID';
